import es from "./src/locales/es";

// src/klaro-config.js
export const klaroConfig = {
  elementID: "cookie-modal",
  acceptAll: true,
  lang: "es",
  translations: {
    es: {
      consentNotice: {
        description:
          "Utilizamos cookies y otras tecnologías para mejorar tu experiencia en este sitio web",
        learnMore: "Configura",
        acceptAll: "Acceptar todo",
        acceptSelected: "Acceptar seleccionadas",
      },
      consentModal: {
        title: "Cookies y otras tecnologías",
        description: "Podemos utilizar cookies para mejorar la experiencia…",
      },
      googleAnalytics: { description: "Estadísticas anónimas (GA4)" },
      googleAds: { description: "Publicidad Google Ads" },
    },
    en: {
      consentNotice: {
        description:
          "We use cookies and other technologies to enhance your experience on this website",
        learnMore: "Configure",
        acceptAll: "Accept all",
        acceptSelected: "Accept selected",
      },
      consentModal: {
        title: "Cookies and other technologies",
        description: "We may use cookies to enhance your experience…",
      },
      googleAnalytics: { description: "Anonymous statistics (GA4)" },
      googleAds: { description: "Google Ads advertising" },
    },
  },

  /* Serveis i Google Consent Mode v2 */
  services: [
    {
      name: "google-tag-manager",
      required: true,
      purposes: ["marketing"],
      onInit: `
        window.dataLayer = window.dataLayer || [];
        window.gtag = function(){dataLayer.push(arguments);}
        gtag('consent','default',{
          ad_storage:'denied',analytics_storage:'denied',
          ad_user_data:'denied',ad_personalization:'denied'
        });
      `,
      onAccept: `
        for(let k in opts.consents){
          if(opts.consents[k]) dataLayer.push({event:'klaro-'+k+'-accepted'});
        }
      `,
    },
    {
      name: "google-analytics",
      cookies: [/^_ga(_.*)?/],
      purposes: ["marketing"],
      onAccept: `gtag('consent','update',{analytics_storage:'granted'});`,
      onDecline: `gtag('consent','update',{analytics_storage:'denied'});`,
    },
    {
      name: "google-ads",
      purposes: ["marketing"],
      onAccept: `gtag('consent','update',{ad_storage:'granted',ad_user_data:'granted',ad_personalization:'granted'});`,
      onDecline: `gtag('consent','update',{ad_storage:'denied',ad_user_data:'denied',ad_personalization:'denied'});`,
    },
  ],
};
